import React from 'react';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';
import { IoStatsChart, IoPeopleOutline, IoSettingsOutline, IoReceiptOutline, IoLogOutOutline, IoArrowBack } from 'react-icons/io5';
import '../style/parallax-star.css';
import '../style/Home.css';
import '../style/Admin.css';
import { getMyRole } from '../utils/jwt';
import { logout as endSession } from '../api/TokenOperations';
import { useLanguage } from '../i18n/LanguageContext';
import { useConfirm } from '../hooks/useConfirm';
import AdminDashboard from '../pages/admin/AdminDashboard';
import AdminUsers from '../pages/admin/AdminUsers';
import AdminSettings from '../pages/admin/AdminSettings';
import AdminAuditLog from '../pages/admin/AdminAuditLog';

const NAV_ITEM_SIZE = 48;
const NAV_ITEM_GAP = 14;
const NAV_ROUTES = ["/admin/", "/admin/users", "/admin/settings", "/admin/audit-log"];

function AdminNavButton({ icon, onClick, title, active }) {
  return (
    <button className={active ? "NaviButton NaviButtonActive" : "NaviButton"} onClick={onClick} title={title} style={{ position: 'relative', zIndex: 1 }}>
      {icon}
    </button>
  );
}

function AdminContent() {
  const history = useHistory();
  const location = useLocation();
  const { t } = useLanguage();
  const [confirm, confirmEl] = useConfirm();

  let activeIndex = NAV_ROUTES.indexOf(location.pathname);
  if (activeIndex === -1 && location.pathname === "/admin") activeIndex = 0;
  if (activeIndex === -1) activeIndex = 0;

  const logout = () => {
    endSession();
    history.replace("/");
  };

  return (
    <div className="parallax-back App-Home-Back">
      {window.cyclone && <div className="TitleBarDragRegion" />}
      <div className="App-Home">
        <div className="Navigator glass">
          <div className="NavIconList">
            <div className="NavIndicator" style={{ transform: `translateY(${activeIndex * (NAV_ITEM_SIZE + NAV_ITEM_GAP)}px)` }}></div>
            <AdminNavButton icon={<IoStatsChart />} onClick={() => history.push("/admin/")} title={t('admin.nav.dashboard')} active={activeIndex === 0} />
            <AdminNavButton icon={<IoPeopleOutline />} onClick={() => history.push("/admin/users")} title={t('admin.nav.users')} active={activeIndex === 1} />
            <AdminNavButton icon={<IoSettingsOutline />} onClick={() => history.push("/admin/settings")} title={t('admin.nav.settings')} active={activeIndex === 2} />
            <AdminNavButton icon={<IoReceiptOutline />} onClick={() => history.push("/admin/audit-log")} title={t('admin.nav.auditLog')} active={activeIndex === 3} />
          </div>
          <button className="NaviButton" onClick={() => history.push("/home")} title={t('admin.nav.backToApp')}><IoArrowBack /></button>
          <button className="NaviButton" onClick={() => confirm({ message: t('settings.logoutConfirm'), confirmLabel: t('nav.logout'), onConfirm: logout })} title={t('nav.logout')}><IoLogOutOutline /></button>
        </div>
        <Route exact path={"/admin/"} component={AdminDashboard} />
        <Route path={"/admin/users"} component={AdminUsers} />
        <Route path={"/admin/settings"} component={AdminSettings} />
        <Route path={"/admin/audit-log"} component={AdminAuditLog} />
        {confirmEl}
      </div>
      <div id='stars'></div>
      <div id='stars2'></div>
      <div id='stars3'></div>
    </div>
  );
}

// Synchronous, render-time gate - unlike Home.js's useEffect-based check,
// this never mounts a single frame of admin UI for a non-admin before
// redirecting. Every admin API call is still independently re-authorized
// server-side (see AdminAPI.js's comment), this is UI-only.
export default function Admin() {
  if (!localStorage.getItem("accessToken") || getMyRole() !== 'admin') {
    return <Redirect to="/home" />;
  }
  return <AdminContent />;
}
